import { render, staticRenderFns } from "./MarketAppCard.vue?vue&type=template&id=8ce41846&scoped=true"
import script from "./MarketAppCard.vue?vue&type=script&lang=js"
export * from "./MarketAppCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce41846",
  null
  
)

export default component.exports